import script from "./last-remover-tab.vue?vue&type=script&lang=ts&setup=true"
export * from "./last-remover-tab.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__